<template>
</template>
<script>
import store from "@/plugins/store";

export default{
  data(){
    return {
      equipmentId: null
    }
  },
  methods:{
    jumpTo(path, query) {
      this.$router.push({path: path, query: query || {}})
    },
    onDecode(equipmentId) {
      const that = this;
      this.$http.post(`/api/booking/getCurrentBooking?equipmentId=${equipmentId}`).then(res => {
        if (res.success) {
          let booking = res.data
          let equipmentId=booking.equipmentId
          console.log("booking",booking.equipmentId)
          if (booking.clientOpen){
            that.$router.push({
              path: '/exp',
              query: {
                equipmentId: equipmentId,
                bookingId: booking.equipmentId
              }
            })
          } else {
            store.commit('setCurBooking', booking)
            that.$router.push({
              path: '/confirm',
              query: {
                equipmentId: equipmentId
              }

            });
          }
        } else {
          that.show = false
          that.prepared = false
          setTimeout(function (){
            that.show = true
          }, 500)
        }
      });
    },
  },
  mounted() {
    this.equipmentId= this.$route.query.equipmentId
    this.onDecode(this.equipmentId)
  }
}
</script>